import { render, staticRenderFns } from "./ReceptionDialogList.vue?vue&type=template&id=396cdf05"
import script from "./ReceptionDialogList.vue?vue&type=script&lang=js"
export * from "./ReceptionDialogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports